
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M12.955 1.929h-9v15h1.5v-13.5h6.5v4h4v11h-10.5v-1.5h-1.5v3h13.5v-14l-4.5-4zm-5.455 7H11v1H7.5v-1zm0 2.5H14v1H7.5v-1zm0 2.5H14v1H7.5v-1z"}})])
          )
        }
      }
    